//公司员工展示
import './index.scss'

import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import FormItem from "antd/es/form/FormItem";

import { Table, Breadcrumb, Space, Button, Modal, Form, Input, Select, Flex } from "antd"
import { useUserListCompany } from '@/hooks/useUserListCompany';

const CompanyDetail = () => {
    const [searchParams] = useSearchParams()
    const companyId = parseInt(searchParams.get('id'))

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showUserId, setShowUserId] = useState(1);
    const [companyData, setCompanyData] = useState({})
    const { userList } = useUserListCompany(companyId)

    const ShowModal = (id) => {
        setShowUserId(id)
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { t } = useTranslation();
    const colums = [
        {
            title: '员工名称',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: ' 账号状态',
            dataIndex: 'locked',
            key: 'locked',
        },
        {
            title: '权限',
            dataIndex: 'power',
            key: 'power',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
        },
        {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button onClick={() => toDepartmentDetail(record.id)} type="primary">
            {t('ButtonList.Check')}
          </Button> */}
                    <Button onClick={() => ShowModal(record.id)}>
                        {t('ButtonList.Update')}
                    </Button>
                    <Button danger>
                        {t('ButtonList.Delete')}
                    </Button>
                </Space>
            )
        },
    ]

    const navigate = useNavigate()
    const toCompanyDisplay = () => {
        navigate(`/CompanyDisplay`)
    }

    return (
        <div>
            <Flex vertical="vertical">
                <Button className='return-btn' type='primary' onClick={toCompanyDisplay}>返回</Button>
                <Table className='company-table' dataSource={userList} columns={colums} rowKey={(record) => record.userId} />
            </Flex>

            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        marginTop: 20,
                        maxWidth: 600,
                    }}
                >
                    <FormItem name="companyName" label="companyName">
                        <Input placeholder={companyData.companyName} />
                    </FormItem>
                    <FormItem name="power" label="power">
                        <Select
                            style={{
                                width: 120,
                            }}
                            options={[
                                {
                                    value: 'banned',
                                    label: 'banned',
                                },
                                {
                                    value: 'normal',
                                    label: 'normal',
                                }
                            ]}
                        />
                    </FormItem>
                </Form>
            </Modal>
        </div>
    )
}

export default CompanyDetail